export interface ParsedTask {
  assignee_name: string;
  text: string;
}

function extractNextStepsSection(content: string): string | null {
  const match = content.match(
    /## Next [Ss]teps\s*\n([\s\S]*?)(?=\n## (?!Next [Ss]teps)|$)/,
  );
  return match?.[1] ?? null;
}

export function parseTasksFromSummary(content: string): ParsedTask[] {
  // Attempt 1: Legacy inline-bracket format
  // [Assignee: task text](https://tasks.zoom.us/...)
  const legacyRegex =
    /\[([^:\]]+):\s*([^\]]+)\]\(https?:\/\/[^).]*tasks\.zoom\.us[^)]*\)/g;
  const tasks: ParsedTask[] = [];
  let match: RegExpExecArray | null;
  while ((match = legacyRegex.exec(content)) !== null) {
    tasks.push({ assignee_name: match[1].trim(), text: match[2].trim() });
  }
  if (tasks.length > 0) return tasks;

  const nextStepsSection = extractNextStepsSection(content);
  if (!nextStepsSection) return tasks;

  // Attempt 2: Heading-based format (Next Steps template)
  // ### Assignee Name
  // - Task text...[](https://tasks.zoom.us?...)
  const headingSections = nextStepsSection.split(/^### /m).slice(1);

  for (const section of headingSections) {
    const lines = section.split("\n");
    const assigneeName = lines[0].trim();
    if (!assigneeName) continue;

    for (const line of lines.slice(1)) {
      const taskMatch = line.match(
        /^[-*]\s+(.+?)\s*\[.*?\]\(https?:\/\/[^)]*tasks\.zoom\.us[^)]*\)/,
      );
      if (taskMatch) {
        const text = taskMatch[1].replace(/\.\s*$/, "").trim();
        if (text) {
          tasks.push({ assignee_name: assigneeName, text });
        }
      }
    }
  }
  if (tasks.length > 0) return tasks;

  // Attempt 3: Bold-name bullet format (General template)
  // - **Assignee Name**
  //     - Task text
  //     - Task text
  const lines = nextStepsSection.split("\n");
  let currentAssignee: string | null = null;

  for (const line of lines) {
    const assigneeMatch = line.match(/^[-*]\s+\*\*(.+?)\*\*/);
    if (assigneeMatch) {
      currentAssignee = assigneeMatch[1].trim();
      continue;
    }

    if (currentAssignee) {
      const taskMatch = line.match(/^\s+[-*]\s+(.+)/);
      if (taskMatch) {
        const text = taskMatch[1].trim();
        if (text) {
          tasks.push({ assignee_name: currentAssignee, text });
        }
      } else if (line.trim() === "") {
        continue;
      } else {
        currentAssignee = null;
      }
    }
  }

  return tasks;
}
